import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Youtube, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { useClinic, waLink } from "../context/ClinicContext";
import { locations } from "../data/locations";

const QUICK = [
  ["Home", "/"],
  ["About Us", "/about"],
  ["Services", "/services"],
  ["X-Ray & Diagnostics", "/diagnostics"],
  ["Gallery", "/gallery"],
  ["Contact", "/contact"],
];

const SERVICES = [
  ["Family Medicine", "/services"],
  ["Diabetes Care", "/services"],
  ["Orthopaedic Consultation", "/services"],
  ["Preventive Health Care", "/services"],
  ["X-Ray — Coming Soon", "/diagnostics"],
];

export const Footer = () => {
  const c = useClinic();
  return (
    <footer className="bg-[#0F1E36] text-slate-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-10">
        <div className="lg:col-span-2">
          <div className="bg-white rounded-xl p-3 inline-block mb-4">
            <Logo />
          </div>
          <p className="text-sm leading-relaxed text-slate-400 max-w-sm">
            Family healthcare, General Physician consultation and diabetes care in New Perungalathur. Digital X-Ray services are coming soon.
          </p>
          <div className="flex gap-3 mt-5">
            {c.instagram && <a href={c.instagram} target="_blank" rel="noreferrer" aria-label="Revive Clinic on Instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#2BB673] flex items-center justify-center transition-colors"><Instagram size={18} /></a>}
            {c.facebook && <a href={c.facebook} target="_blank" rel="noreferrer" aria-label="Revive Clinic on Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#2BB673] flex items-center justify-center transition-colors"><Facebook size={18} /></a>}
            {c.youtube && <a href={c.youtube} target="_blank" rel="noreferrer" aria-label="Revive Clinic on YouTube" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#2BB673] flex items-center justify-center transition-colors"><Youtube size={18} /></a>}
          </div>
        </div>

        <div>
          <h2 className="text-white text-sm font-bold uppercase tracking-wider mb-4">Quick Links</h2>
          <ul className="space-y-2 text-sm">
            {QUICK.map(([label, to]) => <li key={to}><Link to={to} className="hover:text-[#2BB673] transition-colors">{label}</Link></li>)}
          </ul>
        </div>

        <div>
          <h2 className="text-white text-sm font-bold uppercase tracking-wider mb-4">Medical Services</h2>
          <ul className="space-y-2 text-sm">
            {SERVICES.map(([label, to]) => <li key={label}><Link to={to} className="hover:text-[#2BB673] transition-colors">{label}</Link></li>)}
          </ul>
        </div>

        <div className="sm:col-span-2">
          <h2 className="text-white text-sm font-bold uppercase tracking-wider mb-4">Areas We Serve</h2>
          <ul className="grid grid-cols-2 md:grid-cols-3 gap-x-5 gap-y-2 text-sm">
            {locations.map((location) => (
              <li key={location.slug}>
                <Link to={`/family-clinic-in-${location.slug}`} className="hover:text-[#2BB673] transition-colors">
                  {location.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid md:grid-cols-3 gap-8 text-sm">
          <div>
            <h2 className="text-white font-bold mb-4">Get in Touch</h2>
            <ul className="space-y-3">
              <li className="flex gap-3"><Phone size={17} className="text-[#2BB673] shrink-0 mt-0.5" /><a href={`tel:${c.phone}`} className="hover:text-white">{c.phone}</a></li>
              <li className="flex gap-3"><MessageCircle size={17} className="text-[#2BB673] shrink-0 mt-0.5" /><a href={waLink(c.whatsapp)} target="_blank" rel="noreferrer" className="hover:text-white">WhatsApp Us</a></li>
              <li className="flex gap-3"><Mail size={17} className="text-[#2BB673] shrink-0 mt-0.5" /><a href={`mailto:${c.email}`} className="break-all hover:text-white">{c.email}</a></li>
            </ul>
          </div>
          <div>
            <h2 className="text-white font-bold mb-4">Clinic Address</h2>
            <div className="flex gap-3"><MapPin size={17} className="text-[#2BB673] shrink-0 mt-0.5" /><span>{c.address}</span></div>
          </div>
          <div>
            <h2 className="text-white font-bold mb-4">Opening Hours</h2>
            <div className="flex gap-3"><Clock size={17} className="text-[#2BB673] shrink-0 mt-0.5" /><span className="whitespace-pre-line">{c.hours}</span></div>
            <Link to="/contact" className="gradient-bg btn-glow inline-block mt-5 text-white font-bold text-sm px-5 py-2.5 rounded-full">Book an Appointment</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <p>© 2026 Revive Family Clinic & X-Ray Diagnostics. All Rights Reserved.</p>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/privacy" className="hover:text-white">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
